import { FC } from "react";
import { Contact } from "../type/contact";
import { User } from "../../user/type";
import { Descriptions, Popover, Space } from "antd";
import { ShowIf } from "../../../core/component";
import { translate } from "../../../core";
import { CheckSquareOutlined, UserOutlined } from "@ant-design/icons";

export const ContactRelatedUser: FC<{ users?: User[] }> = ({ users }) => (
  <ShowIf
    condition={!!users?.length}
    replacement={<></>}
  >
    <Popover
      title={<Space>
        <UserOutlined />
        {translate('online', 'user')}
      </Space>}
      content={<Descriptions
        layout='vertical'
        bordered
        items={[
          {
            key: 'first_name',
            label: translate('first_name'),
            children: users?.[0]?.firstName,
          },
          {
            key: 'last_name',
            label: translate('last_name'),
            children: users?.[0]?.lastName,
          },
          {
            key: 'email',
            label: translate('email'),
            children: users?.[0]?.email,
          },
          {
            key: 'phone',
            label: translate('phone'),
            children: users?.[0]?.phone,
          },
        ]}
      />}
    >
      <Space style={{ color: "#0564ee" }}>
        <CheckSquareOutlined style={{ fontSize: 20 }} />
        <label>{translate("online")}</label>
      </Space>
    </Popover>
  </ShowIf>
)